export const apiBaseUrl = '/workactivity/back-office/workstream-definition-operation-config';
